module.exports = __webpack_public_path__ + "static/img/Brazil.8ab0d02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/Brazil.svg
// module id = fo60
// module chunks = 10